import { render } from "./ServicesBannerComp.vue?vue&type=template&id=28ad62df&scoped=true"
import script from "./ServicesBannerComp.vue?vue&type=script&lang=js"
export * from "./ServicesBannerComp.vue?vue&type=script&lang=js"

import "./ServicesBannerComp.vue?vue&type=style&index=0&id=28ad62df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ad62df"]])

export default __exports__